import _ from 'lodash';

const rts = {
  handleGet_mediaFeeds: 'handleGet_mediaFeeds',
  handleSet_rssFeeds: 'handleSet_rssFeeds',
  handleSet_rssFeedsNone: 'handleSet_rssFeedsNone',
}

export const rssReducer = (state, action) => {

  const { type, } = action

  switch (type) {

    case rts.handleSet_rssFeeds:
      if (!action.mediaFeeds) return state
      return { ...state, mediaFeeds: action.mediaFeeds }

    case rts.handleSet_rssFeedsNone:
      return { ...state, mediaFeedMessage: action.message }

    default:
      return { ...state }
  }
}

export const rssInitialState = (initState) => {
  return { ...initState }
};

export const rssHandlers = (dispatch) => {
  return {
    handleSet_rssFeeds: (mediaFeeds) => { dispatch({ type: rts.handleSet_rssFeeds, dispatch, mediaFeeds }) },
    handleSet_rssFeedsNone: (message) => { dispatch({ type: rts.handleSet_rssFeedsNone, dispatch, message }) },
  }
}
